module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"selected_kpis":"Selected KPIs({0})","sortMessage":"Unselect then Select in a sorting order","requirement_alert":"Please, select as least 4 KPI!","apply":"Apply","cancel":"Cancel"}}')
  delete Component.options._Ctor
}
